import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import CommonTable, { ITableColumn } from '@/components/common/CommonTable';
import MainHeading from '@/components/common/MainHeading';
import ViewIcon from '@/components/Icons/ViewIcon';
import Layout from '@/components/Layout/Layout';
import { RoutesLink } from '@/utility/RouteLinks';
import moment from 'moment';
import { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  setDateFilter,
  setUpdateFilterStates,
} from '@/redux/features/UserSlice';
import FilterComponent from '@/components/common/FilterComponent';
import useFilter from '@/hooks/useFilter';
import {
  IDeleteResponse,
  IFilterSideBarForm,
  IPageInfo,
} from '@/interfaces/common.model';
import {
  getFilterUrl,
  orderByList,
  showToastNotification,
} from '@/utility/helper';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { IDesignation } from '@/interfaces/designation.mode';
import { IDepartmentList } from '@/interfaces/department.model';
import LockAttConfirmationModal from '@/components/Modal/LockAttConfirmationModal';
import ExportDataHandler from '@/utility/CommonFunctions';
import {
  IDeptResponse,
  IMonthlyTeamAttendanceTableData,
  TDeptDesignationResponse,
  IUserAttendance,
} from '@/interfaces/attendance.model';
import CardLayout from '@/components/Layout/CardLayout';

interface IPageState {
  attendanceList: IMonthlyTeamAttendanceTableData[];
  tableLoader: boolean;
  designationList: IDesignation[];
  departmentList: IDepartmentList[];
  isSalaryCreated: boolean;
  isAttendnaceLocked: boolean;
  isAllDataReceived: boolean;
}

interface ITeamAttendanceResponse {
  status: boolean;
  data: {
    user: IUserAttendance[];
    isAttendnaceLocked: boolean;
    isSalaryCreated: boolean;
    isAllDataReceived: boolean;
    pageInfo: IPageInfo;
  };
  message: string;
}
interface IPagination extends IPageInfo {
  count: number;
  searchQuery: string;
}

const MonthlyTeamAttendance = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const tableView = useSelector((state: RootState) => state?.user?.tableView);
  const dispatch = useDispatch();
  const userDetails = useSelector((state: RootState) => state?.user?.user);
  const filterDetails = useSelector(
    (state: RootState) => state.user.filtersStates,
  );
  const dateFilter = useSelector((state: RootState) => state.user.months);
  const [pagination, setPagination] = useState<IPagination>({
    currentPage: 1,
    count: 0,
    totalPages: 0,
    searchQuery: '',
  });
  const [pageStates, setPageStates] = useState<IPageState>({
    attendanceList: [],
    designationList: [],
    departmentList: [],
    tableLoader: false,
    isSalaryCreated: false,
    isAttendnaceLocked: false,
    isAllDataReceived: false,
  });
  console.log('pageStates', pageStates?.isAllDataReceived);
  const [modal, setModal] = useState<boolean>(false);
  const [modalType, setModalType] = useState<string>('');
  const toggleModal = (type?: string) => {
    if (!pageStates?.isAllDataReceived) {
      showToastNotification(
        'danger',
        'Please Mark All Users Attendance First.',
      );
      return;
    }
    setModalType(type ?? '');
    setModal((prev) => !prev);
  };

  const getAttendanceSummary = useCallback(async () => {
    try {
      const filter = {
        pageNumber: filterDetails?.currentPage,
        pageSize: filterDetails?.pageSize,
        // months: dateFilter[0],
        startDate: dateFilter[0],
        endDate: dateFilter[1],
        departmentId: filterDetails?.department,
        designationId: filterDetails?.designation,
        search: pagination?.searchQuery,
        orderBy: filterDetails?.orderBy,
      };
      const API = `${API_URL}${API_ENDPOINT?.getAttendanceSummary}?${getFilterUrl(filter)}`;
      setPageStates((pre) => ({
        ...pre,
        tableLoader: true,
      }));
      const response: ITeamAttendanceResponse = await callApi(API, {
        method: 'GET',
      });
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.user?.map((item, index) => ({
          ...item,
          id: item?.id,
          sno: index + 1,
          empNameWithImage: item?.name + '##' + item?.profilePhoto,
          employeeCode: item?.employeeCode,
          shiftTime: item?.Shift?.shiftName,
          department: item?.department?.name ?? '',
          officeName: item?.site?.name,
          siteName: item?.usersites?.site?.name,
          presentDays: String(item?.totalAttendance),
          absent: String(item?.totalAbsent),
          leaves: String(
            Number(item?.totalLeave || 0) + Number(item?.totalHalfDays || 0),
          ),
          totalDay: String(item?.totalDays),
          pending: String(item?.totalPending),
          // totalHalfDays: String(item?.totalHalfDays),
          totalFullDayWfh: String(
            Number(item?.totalFullDayWfh || 0) +
              Number(item?.totalHalfDayWfh || 0),
          ),
          // totalHalfDayWfh: String(item?.totalHalfDayWfh),
          pendingAr: String(item?.totalPendingAR),
          pendingOd: String(item?.totalPendingOD),
          pendingLeave: String(item?.totalPendingLeave),
          role: item?.designation?.name ?? '',
          weekOff: item?.weeklyOff != null ? String(item?.weeklyOff) : '--',
          holiday: item?.holiday != null ? String(item?.holiday) : '--',
        }));
        setPageStates((pre) => ({
          ...pre,
          attendanceList: newData,
          isAttendnaceLocked: response?.data?.isAttendnaceLocked,
          isSalaryCreated: response?.data?.isSalaryCreated,
          isAllDataReceived: response?.data?.isAllDataReceived,
        }));
        dispatch(
          setUpdateFilterStates({
            count: response?.data?.pageInfo?.total,
            totalPages: response?.data?.pageInfo?.totalPages,
          }),
        );
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  }, [
    filterDetails?.currentPage,
    filterDetails?.pageSize,
    filterDetails?.department,
    filterDetails?.designation,
    filterDetails?.orderBy,
    dateFilter,
    pagination?.searchQuery,
    dispatch,
  ]);

  const getDepartmentAndDesignation = useCallback(async (id: string) => {
    const url = API_URL + API_ENDPOINT.getDesigantion + `?departmentId=${id}`;
    const res: TDeptDesignationResponse = await callApi(url, { method: 'GET' });
    if (res?.status === true) {
      const data = res.data;
      if ('designation' in data) {
        setPageStates((pre) => ({
          ...pre,
          designationList: data.designation,
        }));
      }
    }
  }, []);

  const loadDepartmentAndDesignation = useCallback(async () => {
    const deptRes: IDeptResponse = await callApi(
      API_URL + API_ENDPOINT.getDepartment,
      { method: 'GET' },
    );
    if (deptRes?.status === true) {
      const departments = deptRes.data.department;
      setPageStates((pre) => ({
        ...pre,
        departmentList: departments,
      }));
      const firstDeptId = departments?.[0]?.id;
      if (firstDeptId) {
        getDepartmentAndDesignation(firstDeptId);
      }
    }
  }, [getDepartmentAndDesignation]);

  useEffect(() => {
    getAttendanceSummary();
  }, [getAttendanceSummary]);

  useEffect(() => {
    loadDepartmentAndDesignation();
  }, [loadDepartmentAndDesignation]);

  const tableHeading: ITableColumn<IMonthlyTeamAttendanceTableData>[] = [
    { value: 'sno', label: 'S.No' },
    { value: 'empNameWithImage', label: 'Employee' },
    { value: 'employeeCode', label: 'Emp. Code' },
    { value: 'department', label: 'Department' },
    { value: 'role', label: 'Designation' },
    { value: 'shiftTime', label: 'Shift' },
    { value: 'officeName', label: 'Office' },
    { value: 'presentDays', label: 'Present' },
    { value: 'absent', label: 'Absent' },
    { value: 'pending', label: 'Pending' },
    { value: 'leaves', label: 'Leaves' },
    // { value: 'totalHalfDays', label: 'Half Day Leaves' },
    { value: 'totalFullDayWfh', label: 'WFH' },
    // { value: 'totalHalfDayWfh', label: 'Half Day WFH' },
    { value: 'pendingAr', label: 'Pending AR' },
    { value: 'pendingOd', label: 'Pending WFH' },
    { value: 'pendingLeave', label: 'Pending Leave' },
    { value: 'totalDay', label: 'Total Days' },
    { value: 'weekOff', label: 'Week Off' },
    { value: 'holiday', label: 'Holiday' },
  ];
  const ActionData = [
    {
      label: 'View',
      className: 'btn btn-link ',
      icon: <ViewIcon />,
      title: 'view',
      clickHandler: (data: IMonthlyTeamAttendanceTableData) =>
        navigate(RoutesLink?.monthlyTeamAttendanceDetail + `/${data?.id}`, {
          state: { data, month: dateFilter },
        }),
    },
  ];

  useEffect(() => {
    loadDepartmentAndDesignation();
  }, [loadDepartmentAndDesignation]);

  const handleData = (
    data: Partial<IFilterSideBarForm> | null,
    type?: string | null,
  ) => {
    if (data?.department && type) {
      getDepartmentAndDesignation(String(data.department));
    }
    if (!type) {
      dispatch(
        setUpdateFilterStates({
          currentPage: 1,
          attendanceStatus: String(data?.attendanceStatus ?? ''),
          attendanceType: String(data?.attendanceType ?? ''),
          department: String(data?.department ?? ''),
          designation: String(data?.designation ?? ''),
        }),
      );
    }
  };

  const singleDateChangeHandler = (date: Date | null) => {
    if (!date || !moment(date).isValid()) return;
    const selectedStartDate = moment(date)
      .startOf('month')
      .format('YYYY-MM-DD');
    const selectedEndDate = moment(date).endOf('month').format('YYYY-MM-DD');
    dispatch(setDateFilter([selectedStartDate, selectedEndDate]));
  };
  const orderByHandler = (e: ChangeEvent<HTMLSelectElement>) => {
    dispatch(
      setUpdateFilterStates({
        orderBy: e.target.value,
      }),
    );
  };
  const { handleSearchChange, handleChangePageSize } = useFilter(
    pagination,
    setPagination,
  );
  const pageChangeHandler = (PageNo: number) => {
    if (PageNo > 0 && PageNo <= filterDetails?.totalPages) {
      dispatch(
        setUpdateFilterStates({
          currentPage: PageNo,
        }),
      );
    }
  };

  const teamAttSortList = {
    department: pageStates?.departmentList,
    designation: pageStates?.designationList,
  };
  const handleLockAtt = async () => {
    try {
      const postData = {
        startDate: dateFilter[0],
        endDate: dateFilter[1],
        siteId: userDetails?.officeId,
      };
      setIsLoading(true);
      const API = API_URL + API_ENDPOINT?.lockAttendance;
      const response: IDeleteResponse = await callApi(API, {
        method: 'POST',
        data: postData,
      });
      setIsLoading(false);
      if (response?.status) {
        toggleModal();
        getAttendanceSummary();
        showToastNotification('success', 'Attendance Locked');
      } else {
        showToastNotification('danger', response?.message);
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  };
  const handleCreateSalary = async () => {
    try {
      const postData = {
        startDate: dateFilter[0],
        endDate: dateFilter[1],
        siteId: userDetails?.officeId,
        userType: '0',
      };
      setIsLoading(true);
      const API = API_URL + API_ENDPOINT?.createMonthlyUserSalary;
      const response: IDeleteResponse = await callApi(API, {
        method: 'POST',
        data: postData,
      });
      setIsLoading(false);
      if (response?.status) {
        toggleModal();
        getAttendanceSummary();
        showToastNotification('success', 'Salary Created');
      } else {
        toggleModal();
        showToastNotification('danger', response?.message);
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  };
  const handleExport = () => {
    const data = {
      userType: 0,
      exportDataType: 'attendanceSummary',
      startDate: dateFilter?.[0],
      endDate: dateFilter?.[1],
      department: filterDetails?.department,
      designation: filterDetails?.designation,
    };
    ExportDataHandler(data);
  };

  const handleDeleteMonthlySalary = async () => {
    try {
      // const postData = {
      //   startDate: dateFilter[0],
      //   endDate: dateFilter[1],
      //   // siteId: userDetails?.officeId,
      //   // userType: '0',
      // };
      setIsLoading(true);
      const API =
        API_URL +
        API_ENDPOINT?.deleteMonthlyUserSalary +
        `?startDate=${dateFilter[0]}&endDate=${dateFilter[1]}`;
      const response: IDeleteResponse = await callApi(API, {
        method: 'DELETE',
        // data: postData,
      });
      setIsLoading(false);
      if (response?.status) {
        toggleModal();
        getAttendanceSummary();
        showToastNotification('success', 'Attendance Deleted');
      } else {
        toggleModal();
        showToastNotification('danger', response?.message);
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Layout>
      <div className="content">
        <MainHeading
          title="Attendance Summary"
          showDefaultDate={true}
          singleDateChangeHandler={singleDateChangeHandler}
          pickerType="month"
          pageState={{
            sortBySingleDate: dateFilter,
          }}
          selectedDate={dateFilter[0]}
        />
        <div className="d-flex justify-content-end align-items-center mb-4">
          <div className="d-flex gap-2">
            {pageStates?.isSalaryCreated == true && (
              <button
                title="Delete Monthly Salary"
                className="btn btn-outline-danger"
                disabled={!pageStates?.isSalaryCreated}
                onClick={() => toggleModal('deleteMonthlySalary')}
              >
                <i className="bi bi-trash"></i>
                {pageStates?.isSalaryCreated
                  ? 'Salary Deleted'
                  : 'Delete Monthly Salary'}
              </button>
            )}
            {pageStates?.isAttendnaceLocked == true &&
              pageStates?.isSalaryCreated == false && (
                <button
                  title="Create Salary"
                  className="btn btn-outline-primary"
                  disabled={pageStates?.isSalaryCreated}
                  onClick={() => toggleModal('createSalary')}
                >
                  <i className="bi bi-coin"></i>
                  {pageStates?.isSalaryCreated
                    ? 'Salary Created'
                    : 'Create Salary'}
                </button>
              )}
            {/* {pageStates?.isAttendnaceLocked && ( */}
            <button
              title={
                pageStates?.isAttendnaceLocked
                  ? 'Attendance Locked'
                  : 'Lock Attendance'
              }
              className="btn btn-outline-primary "
              disabled={pageStates?.isAttendnaceLocked}
              onClick={() => toggleModal('lockAttendance')}
            >
              <i className="bi bi-lock-fill"></i>{' '}
              {pageStates?.isAttendnaceLocked ? 'Locked' : 'Lock Att.'}
            </button>
            {/* )} */}
          </div>
        </div>

        <CardLayout isGrid={tableView === 'grid'}>
          <FilterComponent
            handleSearch={handleSearchChange}
            orderByList={orderByList}
            orderByHandler={orderByHandler}
            sortHandler={handleData}
            filterArray={{
              isShow: true,
              // sortList: sortListOffice,
            }}
            attendanceSortList={teamAttSortList}
            handleExport={
              pageStates?.attendanceList?.length > 0 ? handleExport : null
            }
            searchPlaceHolder={'Search'}
          />

          <CommonTable<IMonthlyTeamAttendanceTableData>
            tableHeading={tableHeading}
            ActionData={ActionData}
            tableData={pageStates?.attendanceList}
            isLoading={pageStates?.tableLoader}
            count={filterDetails?.count}
            totalPages={filterDetails?.totalPages}
            pageSize={filterDetails?.pageSize}
            currentPage={filterDetails?.currentPage}
            handleChangePageSize={handleChangePageSize}
            pageChangeHandler={pageChangeHandler}
          />
        </CardLayout>
        {/* </div>
        </div> */}
      </div>
      <LockAttConfirmationModal
        modal={modal}
        closeHandler={() => toggleModal()}
        submitHandler={
          modalType === 'createSalary'
            ? handleCreateSalary
            : modalType === 'lockAttendance'
              ? handleLockAtt
              : handleDeleteMonthlySalary
        }
        type={modalType}
        isLoading={isLoading}
      />
    </Layout>
  );
};

export default MonthlyTeamAttendance;
